export default __webpack_public_path__ + "static/media/painting.04c27233.jpg";